import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Stack
} from "@mui/material";
import react, { useState, useEffect } from "react";
import { region } from "../../config/images";
import "./Region.css";
import { deleteRegionList, getRegionList, updateRegionList } from "../../config/services";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";

const RegionTable = ({ regionData, setRegionUpdated,
  regionCurrentPage,
  setRegionCurrentPage,
  regionCount,
  perPage }) => {
  const [editRegionPopup, setEditRegionPopup] = useState(false);
  const [deleteRegionPopup, setDeleteRegionPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [regionName, setRegionName] = useState();
  const [regionId, setRegionId] = useState();

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleOpenEditDialog = (e) => {
    setRegionName(e.region_name);
    setRegionId(e.id);
    setEditRegionPopup(true)
  };

  const handleEditRegion = async (e) => {
    e.preventDefault()
    try {
      setLoading(true);
      const params = {
        region_name: regionName
      }
      const resp = await updateRegionList(regionId, params);

      if (resp.data.success == true) {
        setEditRegionPopup(false);
        notifySuccess(resp.data.message);
        setRegionUpdated(true); //  ✅ Trigger region refresh
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const handleOpenDeleteDialog = async (id) => {
    setDeleteRegionPopup(true)
    setRegionId(id);
  };

  const handleDeleteRegion = async (e) => {
    e.preventDefault()
    try {
      setLoading(true);
      const resp = await deleteRegionList(regionId);
      setDeleteRegionPopup(false);
      notifySuccess(resp.data.message);
      setRegionUpdated(true); //  ✅ Trigger region refresh
      setTimeout(() => {
        setLoading(false);
      }, 2000);

    } catch (error) {
      console.log("error");
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handlePageChange = (event, value) => {
    setRegionCurrentPage(value);
  };

  return (
    <>
      <Box style={{ width: "100%", overflowX: "auto" }}>
        <Table className="region-table ">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "50px" }}>
                <Checkbox
                  sx={{
                    color: "rgba(225, 230, 244, 1)",
                    borderRadius: "4px",
                    "&.Mui-checked": {
                      color: "rgba(199, 206, 227,1)",
                    },
                  }}
                />
              </TableCell>
              <TableCell style={{ width: "100px" }}>Sr.No</TableCell>
              <TableCell>Region Name</TableCell>
              <TableCell style={{ width: "100px" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {regionData.map((e, i) => {
              return (
                <TableRow>
                  <TableCell>
                    <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                    />
                  </TableCell>
                  {/* <TableCell>{i + 1}</TableCell> */}
                  <TableCell style={{ textAlign: "center" }}>{i + 1 + (regionCurrentPage - 1) * perPage}</TableCell>
                  <TableCell>{e.region_name}</TableCell>
                  <TableCell>
                    <div className="d-flex gap-3">
                      <img
                        src={region.editIcon}
                        alt=""
                        onClick={() => handleOpenEditDialog(e)}
                        style={{ cursor: "pointer", height: "23px" }}
                      />
                      <img
                        src={region.deleteIcon}
                        alt=""
                        onClick={() => handleOpenDeleteDialog(e.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
      <Box display="flex" justifyContent="end" alignItems="center">
        <Stack spacing={2} className="mb-2">
          <CustomPagination
            count={Math.ceil(regionCount / perPage)}
            page={regionCurrentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Stack>
      </Box>


      <Dialog
        open={editRegionPopup}
        // onClose={() => setEditRegionPopup(false)}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      // className="dialog-assign"
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
              Edit Region
            </h5>
          </div>
        </div>
        <DialogContent>
          <form noValidate autoComplete="off">
            <TextField
              fullWidth
              label="Enter Region"
              name="regionName"
              value={regionName}
              onChange={(e) => setRegionName(e.target.value)}
              className="mb-3"
            />

            <div className="d-flex gap-3 mt-2">
              <button
                className="cancel-button"
                onClick={(e) => { e.preventDefault(); setEditRegionPopup(false) }}
              >
                Cancel
              </button>
              <button
                className="assign-task-button"
                onClick={(e) => handleEditRegion(e)}
                disabled={loading}
              >
                {loading ? <span className="spinner"></span> : "Update Region"}
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteRegionPopup}
        // onClose={() => setDeleteRegionPopup(false)}
        maxWidth="xs"
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogContent className="p-5" style={{ textAlign: "center" }}>
          <Box>
            <img src={region.correct} alt="" />
          </Box>
          <Typography variant="h5" className="pt-4 mb-2">
            <b>Delete this Region </b>
          </Typography>
          <Typography variant="p" className="pt-4" style={{ fontSize: "16px" }}>
            Are you sure you want to <br />
            delete this Region{" "}
          </Typography>
          <div className="d-flex gap-3 pt-4">
            <button
              className="assign-task-button"
              onClick={(e) => handleDeleteRegion(e)}
              disabled={loading}
            >
              {loading ? <span className="spinner"></span> : "Yes"}
            </button>
            <button
              className="assign-task-button"
              onClick={() => setDeleteRegionPopup(false)}
            >
              No
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RegionTable;
